import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);


ScrollTrigger.matchMedia({
  "(min-width: 1025px)": function() {

var hsContainer = '.horizontal-scroll__container'

if (hsContainer) {

  gsap.utils.toArray(hsContainer).forEach((container) => {
    var hsPanels = gsap.utils.toArray('.horizontal-scroll__panel')

  var scrollTween = gsap.to(hsPanels, {
      xPercent: -100 * (hsPanels.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: container,
        pin: true,
        scrub: 1,
        end: "+=3500",
        // fastScrollEnd: true
      }
    });

  gsap.utils.toArray(".horizontal-scroll__toLeft").forEach((toLeft) => {

    gsap.to(toLeft {
      x: -500,
      ease: "none",
      scrollTrigger: {
        trigger: toLeft,
        // containerAnimation: scrollTween,
        start: "=-500",
        end: "=+3500",
        scrub: true
      }
    });

  })

  gsap.utils.toArray(".horizontal-scroll__toRight").forEach((toRight) => {

    gsap.to(toRight, {
      x: 500,
      ease: "none",
      scrollTrigger: {
        trigger: toRight,
        // containerAnimation: scrollTween,
        start: "=-500",
        end: "=+3500",
        scrub: true
      }
    });

  });

});


  let body = $('body');
  body.addClass('no-horizontal-overflow');

}



}});